<template>
  <BaseModal ref="modal" v-model="visible" title="Booking Guide" :width="800" @body-scroll="onBodyScroll">
    <div v-if="loading" class="text-center py-4">Indlæser…</div>
    <div v-else v-html="content" class="booking-guide-content"></div>
    <template #footer>
      <button type="button" class="btn btn-secondary" @click="close">Luk</button>
    </template>
  </BaseModal>
</template>

<script setup>
import { ref, defineExpose, nextTick } from 'vue';
import axios from 'axios';
import BaseModal from './BaseModal.vue';

const visible = ref(false);
const loading = ref(false);
const content = ref('');
const loaded = ref(false);
const modal = ref(null);

function open() {
  visible.value = true;
  if (!loaded.value) {
    fetchContent();
  }
}
function close() { visible.value = false; }

const SCROLL_STORAGE_KEY = 'booking_guide_scroll_position';
function onBodyScroll(pos) {
  // Persist scroll position
  try { localStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(pos)); } catch(e) {}
}
function restoreScroll() {
  try {
    const raw = localStorage.getItem(SCROLL_STORAGE_KEY);
    if (!raw) return;
    const pos = JSON.parse(raw);
    if (pos && typeof pos.x === 'number' && typeof pos.y === 'number') {
      nextTick(() => { modal.value?.scrollTo(pos.x, pos.y); });
    }
  } catch(e) {}
}

async function fetchContent() {
  loading.value = true;
  try {
    const resp = await axios.get('/administration/booking_guide', { headers: { Accept: 'application/json' } });
    if (resp.data && resp.data.content) {
      content.value = resp.data.content;
    } else {
      content.value = '<div style="color:#888;text-align:center;">Ingen booking guide fundet.</div>';
    }
  } catch (e) {
    content.value = '<div style="color:#c00;text-align:center;">Kunne ikke hente booking guide.</div>';
  } finally {
    loading.value = false;
    loaded.value = true;
    restoreScroll();
  }
}

defineExpose({ open, close });

</script>

<style lang="scss" scoped>
</style>
